<div style="max-width: 300px" class="mt-3">
  <form [formGroup]="form">
    <ng-container *ngFor="let field of fields">
      <container-element [ngSwitch]="field.type">
        <app-form-field [label]="field.header" *ngSwitchCase="'color'">
          <span>
            <p-colorPicker
              [formControlName]="field.field"
              appendTo="body"
              (ngModelChange)="input.value = ''"
            ></p-colorPicker>
            <input
              #input
              pInputText
              [formControlName]="field.field"
              [style]="'color:' + form.get(field.field)?.value"
              (keydown.enter)="save()"
            />
          </span>
        </app-form-field>
        <app-form-field [label]="field.header" *ngSwitchCase="'checkbox'">
          <p-checkbox [formControlName]="field.field" [binary]="true"></p-checkbox>
        </app-form-field>
        <app-form-field [label]="field.header" *ngSwitchCase="'refView'">
          <p-dropdown
            class="w-full"
            [options]="views"
            [formControlName]="field.field"
            placeholder="Vues - représentations"
            appendTo="body"
          ></p-dropdown>
        </app-form-field>
        <app-form-field [label]="field.header" *ngSwitchCase="'referential'">
          <p-dropdown
            class="w-full"
            [options]="refValues[field.referential || ''] || []"
            optionLabel="name"
            optionValue="id"
            [formControlName]="field.field"
            [showClear]="true"
            placeholder="-"
            appendTo="body"
          ></p-dropdown>
        </app-form-field>
        <app-form-field [label]="field.header" *ngSwitchDefault>
          <input pInputText [formControlName]="field.field" (keydown.enter)="save()" [type]="field.type || ''" />
        </app-form-field>
      </container-element>
    </ng-container>
  </form>

  <button
    *ngIf="!processing"
    pButton
    label="Enregistrer"
    (click)="save()"
    [style.opacity]="form?.invalid ? 0.5 : 1"
  ></button>
  <p-progressSpinner
    *ngIf="processing"
    [style]="{ width: '30px', height: '30px' }"
    [strokeWidth]="'2px'"
  ></p-progressSpinner>
</div>
